import React from "react";
import { useSelector } from "react-redux";
import { useTable, useBlockLayout } from "react-table";
import { TableWrapper, Table, Thead, Tbody, Tr, Th, Td } from "./styles";
import {
  DEFAULT_COLORS,
  DEFAULT_FONT_STYLES,
  DEFAULT_FONT_SIZES,
} from "consts";

// https://github.com/tannerlinsley/react-table/issues/3087
const mapColumns = columns =>
  columns.map(column => {
    return {
      ...column,
      accessor: rows => rows[column.Header],
    };
  });

export const ReactTable = ({ columns, data }) => {
  const mappedColumns = React.useMemo(() => mapColumns(columns), [columns]);
  const questionnaire = useSelector(state => state.questionnaires[0]);
  const colors = questionnaire.colors;
  const backgroundColor =
    colors.table_background || DEFAULT_COLORS.table_background;
  const textColor = colors.table_text || DEFAULT_COLORS.table_text;
  const headerColor = colors.table_header || DEFAULT_COLORS.table_header;
  const fontSize =
    questionnaire.font_sizes.table_text || DEFAULT_FONT_SIZES.table_text;
  const fontStyle =
    questionnaire.font_styles.table_text || DEFAULT_FONT_STYLES.table_text;
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
  } = useTable(
    {
      columns: mappedColumns,
      data,
    },
    useBlockLayout,
  );

  return (
    <TableWrapper
      tableHeight={{
        lg: "300px",
        md: "275px",
        sm: "250px",
      }}
    >
      <Table
        {...getTableProps()}
        backgroundColor={backgroundColor}
        textColor={textColor}
        className="table ui-table"
      >
        <Thead className="ui-table-thead">
          {headerGroups.map(headerGroup => (
            <Tr
              key={headerGroup}
              {...headerGroup.getHeaderGroupProps()}
              className="ui-table-tr"
            >
              {headerGroup.headers.map(column => {
                return (
                  <Th
                    key={column}
                    {...column.getHeaderProps()}
                    className="ui-table-th"
                    headerColor={headerColor}
                    fontSize={fontSize}
                    fontStyle={fontStyle}
                  >
                    <text>{column.render("Header")}</text>
                  </Th>
                );
              })}
            </Tr>
          ))}
        </Thead>

        <Tbody {...getTableBodyProps()} className="ui-table-tbody">
          {rows.map(row => {
            prepareRow(row);
            return (
              <Tr key={row} {...row.getRowProps()} className="ui-table-tr">
                {row.cells.map((cell, _index) => {
                  return (
                    <Td
                      key={cell}
                      {...cell.getCellProps()}
                      className="ui-table-td"
                      fontSize={fontSize}
                      fontStyle={fontStyle}
                    >
                      {cell.value}
                    </Td>
                  );
                })}
              </Tr>
            );
          })}
        </Tbody>
      </Table>
    </TableWrapper>
  );
};
